app.service('basketHomeDelivery', function (modal, updateServicePrices, updateExcludedServices, broker) {
	var $self, $form, $servicesOnModal, $summary;

	function open() {
		modal.open('home-delivery-promotion-message');
	}

	function changeQuantity(value, productId, serviceId){
		let $service = $servicesOnModal.filter('[data-product='+productId/1+']').filter('[data-service='+serviceId+']');
		if($service.length){
			$service.attr('data-quantity', value);
		} else {
			console.log('Brak usługi do zmiany')
		}
	}
	function setElements() {
		$self = $('#modal-home-delivery-promotion-message');
		$summary = $('.js-services-summary-price', $self);
		$form = $('form', $self);
		$servicesOnModal = $('.js-service', $form);
		$servicesQuantityOnModal = $('.js-service-modal-quantity', $form);
	}

	function setEvents() {

		$('.js-confirm-home-delivery', $self).on('click', function () {
			modal.close();
			broker.trigger('CONFIRM_HOME_DELIVERY');
		});
		$('.js-resign-home-delivery', $self).on('click', function () {
			modal.close();
			broker.trigger('RESIGN_HOME_DELIVERY');
		});
		broker.on('REFRESH_BASKET_VIEW', function () {
			modal.destroy('home-delivery-promotion-message');
		});
		$servicesQuantityOnModal.on('change', function() {
			changeQuantity($(this).val(), $(this).data('product'), $(this).data('service'));
			updateServicePrices.run({
				$inputs: $servicesOnModal,
				$box: $summary
			});
		});
		$servicesOnModal.on('click', function () {
			updateExcludedServices.run({
				$input: $(this),
				$inputs: $servicesOnModal
			});
			updateServicePrices.run({
				$inputs: $servicesOnModal,
				$box: $summary
			});
		});
	}
	function init() {
		setElements();
		setEvents();
	}
	return {
		init,
		open
	};
});